import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function TrapSection() {
  return <section className="py-20 px-6 bg-[var(--bg-deep)]" data-id="element-347">
      <div className="max-w-[680px] mx-auto" data-id="element-348">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-[var(--bg-elevated)] rounded p-8 md:p-10 border border-[var(--bg-surface)]" data-id="element-349">
          <div className="flex items-center gap-3 mb-6" data-id="element-350">
            <AlertTriangle className="text-[var(--red-emphasis)] w-6 h-6" data-id="element-351" />
            <h3 className="text-xl font-serif font-bold text-[var(--text-heading)] uppercase tracking-wide" data-id="element-352">
              La trampa del silencio
            </h3>
          </div>

          <div className="space-y-6 text-lg text-[var(--text-muted)]" data-id="element-353">
            <p data-id="element-354">
              En ese silencio de Dios, el enemigo te susurra su mentira más
              cruel:
            </p>
            <p className="text-[var(--text-primary)] font-serif italic text-xl pl-4 border-l-2 border-[var(--red-emphasis)]" data-id="element-355">
              "Esto es permanente. No hay salida. Dios se olvidó de ti."
            </p>
            <p data-id="element-356">
              Ese es el momento más peligroso. No cuando caes. <br data-id="element-357" />
              <span className="text-[var(--text-heading)] font-bold" data-id="element-358">
                Sino cuando empiezas a creer que ya no te van a recoger.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}